/** Passo do fluxo SMS no formulário de login. */
export enum LoginFormStep {
  Phone = 'phone',
  Code = 'code',
}

/** Estado visual do feedback automático do OTP. */
export enum LoginFormOtpFeedback {
  Idle = 'idle',
  Verifying = 'verifying',
  Success = 'success',
  Error = 'error',
}

/** Provedores sociais exibidos no login (valores alinhados a `SocialProvider`). */
export enum LoginFormSocialProvider {
  Google = 'google',
  Facebook = 'facebook',
}
